import React from "react";
import ProjetoLayout from "../componentes/ProjetoLayout";

function ComparadorImoveis() {
  return (
    <ProjetoLayout
      titulo="Comparador de Imóveis"
      tagline="Dashboard dinâmico e interativo com análise aprofundada do mercado imobiliário de Joinville."
      liveUrl="https://buscador-imoveis.vercel.app"
      capa="/capa-comparador-imoveis.png"
      capaAlt="Comparador de Imóveis"
      tags={[
        "React",
        "Next.js",
        "Node.js",
        "Supabase",
        "Web Scraping",
        "n8n",
        "JavaScript",
      ]}
      meta={[
        { ic: "code", label: "Tipo", value: "Full-stack" },
        { ic: "role", label: "Papel", value: "Desenvolvedor" },
        { ic: "local", label: "Mercado", value: "Joinville · SC" },
      ]}
    >
      <h2>Inteligência do mercado imobiliário</h2>
      <p>
        Este projeto é um <strong>dashboard dinâmico e interativo</strong> que
        oferece uma análise aprofundada do mercado imobiliário de Joinville. Foi
        desenvolvido para dar uma visão clara do setor, permitindo consultar
        preços, identificar oportunidades e acompanhar indicadores-chave de forma
        intuitiva.
      </p>
      <p>
        Para alimentar a plataforma com dados precisos, implementei uma{" "}
        <strong>automação de web scraping com n8n</strong> que varre um portal de
        imóveis regional, coletando e estruturando todas as ofertas da cidade. O
        design seguiu a filosofia <strong>Mobile First</strong>, com experiência
        totalmente responsiva.
      </p>

      <h3>Principais funcionalidades</h3>
      <ul>
        <li>
          <strong>Indicadores gerais:</strong> total de imóveis cadastrados, preço
          médio do m² e bairro mais valorizado, em um panorama instantâneo.
        </li>
        <li>
          <strong>Análise de oportunidade:</strong> simulação que compara o valor
          informado com a média de mercado para imóveis semelhantes.
        </li>
        <li>
          <strong>Consulta por bairro:</strong> lista pesquisável com o preço
          médio do m² em cada bairro, com paginação.
        </li>
        <li>
          <strong>Filtro por tipo:</strong> imóveis agrupados por categoria (casas,
          apartamentos, lotes) para simplificar a análise.
        </li>
      </ul>
    </ProjetoLayout>
  );
}

export default ComparadorImoveis;
